import React from "react";
import { useI18n } from "../providers/I18nProvider";

interface BetDeclinedModalProps {
  onContinue: () => void;
}

export const BetDeclinedModal: React.FC<BetDeclinedModalProps> = ({
  onContinue,
}) => {
  const { t } = useI18n();

  return (
    <div className="pt-6 px-4 pb-3 flex flex-col items-center">
      <div className="text-center text-25 mb-8">
        {t("BetSlipWidgetBetDeclinedMessage")}
      </div>

      <button
        onClick={onContinue}
        className="w-full text-25 py-1 h-[45px] bg-btn-continue-betting text-btn-continue-betting-text rounded-4 mt-9"
      >
        {t("BetSlipWidgetBetDeclinedContinue")}
      </button>
    </div>
  );
};

export default BetDeclinedModal;
